<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/thy1ia/tc-custom/9781685505479.jpg?1723405794425" alt="This image is the cover for the book The Spectator"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Spectator
      </h1>
      <p class="bookDescription body article font2">
        <p>Regina is used to getting what she wants. When she meets Shane, the brooding art school grad turned ad exec at her PR firm, the two fall in love and get married right away. But five years into their marriage, Shane's frustrations only seem to grow and Regina tries everything to mend the relationship -- new sex, vacation time, and long nights discussing their future.<br/><br/>Finally, when Regina suggests a threesome, everything seems to click. Shane surprises her when he says he wants to explore his bisexual side by inviting a man into their bed.<br/><br/>Together they frequent downtown Toronto and Regina's night classes to see if they can find the perfect man to join them.<br/><br/>When they meet a blond, Adonis-like stranger, they think everything's set. So why is Shane suddenly getting cold feet?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eve Morton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?920d68a2